import React, { createContext, useContext, useReducer } from 'react';
import '../../../cssAlt/AppM.css';
import { ParentContext } from '../../../global/cnr/contexts/ParentContext';
import { UiItemContext } from '../../../global/cnr/contexts/UiItemContext';
import { gEnums } from '../../../global/enums/globalEnums';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { createSportsHandlers, createSportsInitialState, createSportsReducer } from '../cnr/reducers/CreateSportsReducer';

import { _sportsTournamentViewModes } from '../cnr/reducers/SportsTournamentReducer';
import BackupSeasons from './BackupSeasons';

const TryoutList = React.lazy(() => import('../elements/athletes/TryoutList'));
const CreateRoster = React.lazy(() => import('./subs/CreateRoster'));
const EditSeasonal = React.lazy(() => import('./subs/EditSeasonal'));
const SportsDataPaste = React.lazy(() => import('./subs/SportsDataPaste'));
const ValidateSports = React.lazy(() => import('./subs/ValidateSports'));
const CreateSportsDetails = React.lazy(() => import('./subs/SportsSeasonDetails'));

const SportTournamentPage = React.lazy(() => import('../pages/SportsTournamentPage'));
const CreateActiveSports = React.lazy(() => import('./CreateActiveSports'));
const CreateAllStarTeams = React.lazy(() => import('./CreateAllStarTeams'));
const CreatePlayoff = React.lazy(() => import('./CreatePlayoff'));
const CreateRankings = React.lazy(() => import('./CreateRankings'));
const CreateSeason = React.lazy(() => import('./CreateSeason'));
const CreateSportsTeams = React.lazy(() => import('./CreateSportsTeams'));

const _teamItemsToRemove = ['id', 'position', 'record', '_itemKey']

export const CreateSportsContext = createContext();

const CreateSports = (props) => {

  const _asat = gEnums.availableSubActionTypes

  const { subActionType, viewItem, handleActionPreview, commitSub, handleCancel, fromDashboard, fromApp } = props

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state, item_handlers } = uiItemContext ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { teams_info, currentSeason_info, parentDataKeys, sportPermissions } = sportsSeason_state ?? {}
  const { latestSeason, sportsKey, _sportsYearAbr, _sportsAbr, _sportsModeKey, _sportsModeSport } = currentSeason_info ?? {}

  const { teams, teams_fromMatches } = teams_info ?? {}

  const _teams = teams ? _.cloneDeep(teams) : {}

  // ammnend the teams
  if (_teams) {
    Object.keys(_teams).forEach(tk => {
      _teamItemsToRemove.forEach(ti => {
        // delete _teams[tk][ti]
      })
    })
  }

  const _latestSeason = latestSeason ? latestSeason : props.latestSeason

  const init_state = {
    // database_fns,
    item_state,
    latestSeason: _latestSeason,
    parentDataKeys,
    pathViews,
    selectedAthletes: [],
    sportPermissions,
    sportsKey, // YES
    subActionType, // ScheduleCalendar
    teams_fromMatches,
    teams_info, // YES
    teams: _teams, // YES
  }
  const [createSports_state, createSports_dispatch] = useReducer(createSportsReducer, init_state, createSportsInitialState)
  const createSports_handlers = createSportsHandlers(createSports_dispatch, createSports_state)

  const content = () => {

    switch (subActionType) {

      case _asat.backupSeason:
        return <BackupSeasons viewItem={viewItem} handleCancel={handleCancel} fromDashboard={fromDashboard} />

      case _asat.createSeason:
      case _asat.editSeason:
        return <CreateSeason
          viewItem={viewItem}
          handleActionPreview={handleActionPreview}
          commitSub={commitSub}
          alignmentOnly={true}
          handleCancel={handleCancel}
          fromDashboard={fromDashboard}
          subActionType={subActionType}
        />

      case _asat.editSeason:
      case _asat.editSeasonDetails:
      case _asat.sportsSettings:
        return <CreateSportsDetails subActionType={subActionType} />

      case _asat.nominatePlayers:
      case _asat.createAllStarTeams:
        return <CreateAllStarTeams viewItem={viewItem} handleActionPreview={handleActionPreview} commitSub={commitSub} subActionType={subActionType} fromDashboard={fromDashboard} />

      case _asat.createHistory:
        return <CreateAllStarTeams viewItem={viewItem} handleActionPreview={handleActionPreview} commitSub={commitSub} fromDashboard={fromDashboard} />

      case _asat.createSportsTeams:
        return <CreateSportsTeams viewItem={viewItem} handleActionPreview={handleActionPreview} commitSub={commitSub} alignmentOnly={true} fromDashboard={fromDashboard} />

      case _asat.createSportsHandlers:
        return <CreateSeason viewItem={viewItem} handleActionPreview={handleActionPreview} commitSub={commitSub} alignmentOnly={true} handleCancel={handleCancel} fromDashboard={fromDashboard} />

      case _asat.createPlayoff:
        return <CreatePlayoff viewItem={viewItem} handleActionPreview={handleActionPreview} commitSub={commitSub} handleCancel={handleCancel} fromDashboard={fromDashboard} fromApp={fromApp} />

      case _asat.createRoster:
        return <CreateRoster subActionType={subActionType} />

      case _asat.editTryoutRoster:
        return <TryoutList handleCancel={handleCancel} fromDashboard={fromDashboard} />

      case _asat.createStaff:
        return <SportsDataPaste subActionType={subActionType} fromDashboard={fromDashboard} />

      case _asat.createRankings:
      case _asat.submitRankings:
        return <CreateRankings handleActionPreview={handleActionPreview} commitSub={commitSub} handleCancel={handleCancel} fromDashboard={fromDashboard} />

      case _asat.createTournament:
        return <SportTournamentPage sportsTournamentViewMode={_sportsTournamentViewModes.editTournament} />

      case _asat.createTournamentPlayoff:
        return <SportTournamentPage sportsTournamentViewMode={_sportsTournamentViewModes.editPlayoff} />

      case _asat.updateDistricts:
      case _asat.updateOrganizations:
        return <CreateActiveSports subActionType={subActionType} handleCancel={handleCancel} fromDashboard={fromDashboard} />

      case _asat.updateOrganizationSports:
      case _asat.updateLeagueSports:
      case _asat.updateSchoolSports:
        return <CreateActiveSports subActionType={subActionType} handleCancel={handleCancel} fromDashboard={fromDashboard} />

      case _asat.sportsDashboard:
        return <ValidateSports fromDashboard={fromDashboard} />

      default:
        return <div>{'subActionType is not recognized'}</div>
    }
  }

  const wrapper = () => <CreateSportsContext.Provider value={{ createSports_state, createSports_handlers, viewItem, handleActionPreview, item_handlers }}>
    {content()}
  </CreateSportsContext.Provider>

  return wrapper()
}

export default CreateSports